module.exports = __webpack_public_path__ + "static/img/admissionConsult.dba80e5a.png";